import { CheckoutFlow, setPaymentAttempt } from '@src/telemetry/checkout-attempts'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

export type UnifiedPaymentGateway = 'STRIPE' | 'PAYPAL' | 'AMAZON' | 'BRAINTREE'

export const trackUnifiedPayButtonClick = ({
  flow,
  paymentMethod,
  errorReason,
}: {
  flow: CheckoutFlow
  paymentMethod: string
  errorReason?: string
}) => {
  trackEvent(TELEMETRY_EVENT_NAMES.UNIFIED_PAY_BUTTON_CLICK, {
    flow,
    paymentMethod,
    errorReason,
  })
}

export const trackUnifiedPaymentInitiated = ({ paymentGateway }: { paymentGateway: UnifiedPaymentGateway }) => {
  trackEvent(TELEMETRY_EVENT_NAMES.UNIFIED_PAYMENT_INITIATED, {
    paymentGateway,
  })
}

export const trackUnifiedPaymentAuthorised = () => {
  trackEvent(TELEMETRY_EVENT_NAMES.UNIFIED_PAYMENT_AUTHORISED, {})
}

export const trackCheckoutErrorLog = ({ errorReason }: { errorReason?: string } = {}) => {
  trackEvent(TELEMETRY_EVENT_NAMES.CHECKOUT_ERROR_LOG_WEB_CHECKOUT, {
    errorReason,
  })
}

export const initializeUnifiedPayButtonClick = ({
  flow,
  paymentMethod,
  paymentGateway,
}: {
  flow: CheckoutFlow
  paymentMethod: string
  paymentGateway?: UnifiedPaymentGateway
}) => {
  setPaymentAttempt({
    flow,
    payment_method: paymentMethod,
    payment_gateway: paymentGateway,
  })
  trackUnifiedPayButtonClick({ flow, paymentMethod })
}
